import React from 'react';

const Footer = () => (
	<footer>
	</footer>
)

export default Footer;



// WEBPACK FOOTER //
// ./src/layouts/public/footer/Footer.js